export default "__VITE_ASSET__DVw0Ivo$__"